import {setDisplayName} from 'recompose'

import {memo} from 'react'
import type {ComponentType} from 'react'

import {wrapDisplayName} from '../library/utils/getDisplayName'

export const memoWithDisplayName = <P>(component: ComponentType<P>) =>
  setDisplayName(wrapDisplayName(component, 'memo'))(memo(component))
